import { useQuery } from '@tanstack/react-query';
import { sagaMonitorApi } from '../api/sagaMonitorApi';
import type { SagaInstanceFilter } from '../types/sagaMonitor';

/**
 * GET /api/eraf/saga-monitor/instances — 사가 인스턴스 목록 (SAGA_MONITOR_READ)
 * queryKey: ['saga-monitor', 'list', filters]
 */
export function useSagaInstances(filter: SagaInstanceFilter) {
  return useQuery({
    queryKey: ['saga-monitor', 'list', filter],
    queryFn: () => sagaMonitorApi.listInstances(filter),
    staleTime: 15_000,
  });
}
